<template>
  <div class="collaborator-container">
    <div class="collaborator-project_image">
      <img
        class="collaborator-banner"
        :src="require('@/assets/images/login/logo.png')"
        alt=""
      />
    </div>
    <div class="collaborator-title">
      <h6>DTP药房专业化能力建设系统志愿者登录</h6>
    </div>
    <div class="collaborator-main">
      <div class="collaborator-form">
        <div class="collaborator-content">
          <div class="collaborator-block">
            <div class="collaborator-block_key global_primary_text_color">
              <img :src="require('@/assets/images/login/phone.png')" alt="" />
            </div>
            <div class="collaborator-block_value">
              <div class="login-clunmu-input">
                <el-input
                  placeholder="请输入账号"
                  @input="changePhone"
                  v-model="data.phone"
                ></el-input>
              </div>
            </div>
          </div>
          <div class="collaborator-block">
            <div class="collaborator-block_key global_primary_text_color">
              <img :src="require('@/assets/images/login/lock.png')" alt="" />
            </div>
            <div class="collaborator-block_value">
              <div class="login-clunmu-input">
                <el-input
                  placeholder="请输入验证码"
                  @input="checkCode"
                  v-model="data.code"
                >
                  <template #append>
                    <el-button
                      type="primary"
                      class="login-code"
                      slot="append"
                      @click.native="getCode"
                      >{{ text }}</el-button
                    >
                  </template>
                </el-input>
              </div>
            </div>
          </div>
        </div>
        <div class="btn_group">
          <iconButton
            :iconSrc="require('@/assets/images/login/login_icon.png')"
            @doClick="doCommit"
          >
            <template #default>
              <div>登录</div>
            </template>
          </iconButton>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import iconButton from "@/components/unit/iconButton";
import event from "../../../common/event";
import { ElInput, ElButton } from "element-plus";
export default {
  name: "Login",
  mixins: [event],
  data() {
    return {
      data: {
        phone: "",
        code: "",
      },
      codeLoading: false,
      loading: false,
      startTime: 0,
      text: "",
    };
  },
  components: {
    iconButton,
  },
  created() {
    let data = this.$tools.getStorage("sales-login-data", localStorage) || {};
    this.data = {
      ...this.data,
      ...data,
    };
    this.startTime =
      this.$tools.getStorage("sales-login-time", localStorage) || 0;
    this.text = this.getText();
    this.runTimer();
  },
  beforeUnmount() {
    this.changeIndex();
  },
  methods: {
    getText() {
      let second = Math.floor((Date.now() - this.startTime) / 1000);
      if (!this.startTime || second > 60) {
        this.startTime = 0;
        return "获取验证码";
      }
      return `${60 - second}s`;
    },
    checkCode() {
      this.data.code = this.data.code.replace(/[^\w]/g, "");
    },
    changePhone() {
      this.data.phone = this.data.phone.replace(/\D/g, "").slice(0, 11);
    },
    getCode() {
      if (this.codeLoading || this.startTime) return;
      if (!/^1[3-9]\d{9}$/.test(this.data.phone)) {
        this.$tips.error({ text: "请输入正确的手机号！" });
        return false;
      }
      this.codeLoading = true;
      this.$axios
        .get(`${this.$urls.user.code}?phone=${this.data.phone}`)
        .then((res) => {
          this.startTime = Date.now();
          this.codeLoading = false;
          this.$tools.setStorage(
            "sales-login-time",
            this.startTime,
            localStorage
          );
        })
        .catch((error) => {
          setTimeout(() => {
            this.codeLoading = false;
          }, 1000);
        });
    },
    dealWithEvent() {
      if (!this.startTime) return;
      this.text = this.getText();
    },
    verifyData() {
      if (!this.data.phone) {
        this.$tips.error({ text: "请输入手机号" });
        return false;
      }
      if (!/^1[3-9]\d{9}$/.test(this.data.phone)) {
        this.$tips.error({ text: "请输入正确的手机号！" });
        return false;
      }
      if (!this.data.code) {
        this.$tips.error({ text: "请输入验证码" });
        return false;
      }
      return true;
    },
    doCommit() {
      if (!this.verifyData()) return;
      if (this.loading) return;
      this.loading = true;
      this.$axios
        .post(this.$urls.user.login, this.data)
        .then((res) => {
          this.$tools.setStorage("sales-login-data", this.data, localStorage);
          this.$tools.setStorage("sales-login-data", this.data, sessionStorage);
          this.$store.dispatch("setItem", { salesInfo: res.data });
          this.$router.push({
            path: "/myMeet",
          });
          setTimeout(() => {
            this.loading = false;
          }, 1000);
        })
        .catch((err) => {
          setTimeout(() => {
            this.loading = false;
          }, 1000);
        });
    },
  },
};
</script>

<style>
.collaborator-container {
  /* padding-bottom: 38px; */
  background-image: url("../../../assets/images/login/login_background.jpg");
  background-size: 100% 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  height: 100%;
  width: 100%;
  position: relative;
  justify-content: space-between;
  overflow: auto;
}

.collaborator-project_image {
  padding: 2.33rem 2.43rem 1.83rem 2.43rem;
}

.collaborator-project_image img {
  width: 100%;
  height: auto;
}

.collaborator-main {
  flex: 1 0 0;
  z-index: 2;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding-bottom: 40px;
}

.collaborator-form {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 80%;
}

.input_background {
  background: #fdf3fb;
}

.collaborator-block {
  height: 38px;
  background: #fdf3fb;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 15px;
  border-radius: 75px;
}

.collaborator-block input {
  border: none;
  font-size: 14px;
  padding-left: 0;
  padding-right: 0;
}

.collaborator-block_key {
  flex: 45px 0 0;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.collaborator-block_key img {
  width: auto;
  height: 16px;
}

.collaborator-block_value {
  flex: 1 0 0;
  border-left: 1px solid #cecece;
  padding-left: 10px;
}

.btn_group,
.collaborator-btn_group {
  width: 185px;
  margin-top: 20px;
  height: 35px;
}

/* .collaborator-btn_group button {
  width: 100%;
  height: 100% !important;
  min-height: 35px !important;
  border-radius: 75px;
}
.collaborator-btn_group .el-button {
  border-radius: 75px;
  background: url("../../../assets/images/login/btn.png");
  background-size: 100% 100%;
  border: none !important;
  background-repeat: no-repeat;
}
.collaborator-btn_group .el-button.is-round{
  padding: 0 !important;
} */

.collaborator-title {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--el-color-primary);
  margin-bottom: 55px;
}

.collaborator-container .el-input-group__append {
  border-radius: 5px !important;
  background: var(--el-color-primary) !important;
  color: #fff !important;
  border: none;
}

.login-code {
  padding: 6px 10px;
  line-height: 0;
}

.login-code span {
  display: inline-block;
  padding: 3.75px 7.5px;
  font-size: 12px;
}

.collaborator-container .login-clunmu-input {
  height: 100%;
  width: 95%;
  display: flex;
  align-items: center;
  position: relative;
}

.collaborator-container .login-clunmu-input input {
  height: 25px;
  line-height: 25px;
  padding: 0;
  margin: 0;
  background: #fdf3fb !important;
  color: #8c8b8c;
}

.collaborator-container .login-clunmu-input input::placeholder {
  color: #8c8b8c;
}

.collaborator-container .login-clunmu-input .el-input {
  line-height: normal !important;
}

.collaborator-banner {
  width: 100%;
  height: auto;
}

.select_container_center {
  color: #fff;
  width: 80%;
  font-size: 12px;
  /* background:rgba(224,224,224,0.9); */
  padding: 7.5px 15px;
  border-radius: 7.5px;
}

.select_container {
  color: #fff;
  height: 265px;
  font-size: 12px;
  width: 80%;
  overflow: hidden;
  /* background:rgba(224,224,224,0.9); */
  padding: 7.5px 15px;
  border-radius: 7.5px;
}

.select_title {
  width: 100%;
  display: flex;
  justify-content: center;
  font-weight: 700;
}

.select {
  width: 100%;
}

.select_ul {
  display: flex;
  align-items: center;
  border-bottom: 1px solid #fff;
  padding: 15px;
}

.select_ul:last-child {
  border: none;
}

.select_ul .el-radio {
  margin-right: 0;
}

.select_ul .el-radio__label {
  padding: 0;
  width: 0;
}

.select_radio_label {
  word-break: break-all;
  margin-left: 15px;
}

.collaborator-button_block {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 15px;
  font-size: 12px;
}

.collaborator-button_block img {
  height: 100%;
  width: auto;
  margin-right: 7px;
}
</style>
